



















































































































import 'jsoneditor/dist/jsoneditor.min.css'
import Component, {mixins} from 'vue-class-component'
import Wamp from '@/modules/core/wamp/mixins/Wamp'
import {ISubscription, SubscribeHandler, Session} from 'autobahn';
import JSONEditor, {JSONEditorOptions} from 'jsoneditor';
import {Ref} from 'vue-property-decorator';

export interface Topic {
    name: string
    subscription: ISubscription
    messages: any[]
    currentMessage: string
}


@Component
export default class WampManager extends mixins(Wamp) {
    public connected = false
    public subscribed = false
    public session: Session | null = null
    public subscribeDialog = false
    public newTopic = ''
    public newMessageDialog = false
    public currentTopic = ''
    public newConnectionDialog = false

    @Ref()
    public editorContainer: HTMLDivElement
    public jsonEditor: JSONEditor | null = null

    public topics: {[name: string]: Topic} = {}
    public recentTopics: string[] = []

    public async connect () {
        this.session = await this.$wamp.connect()
        this.connected = true
    }

    public async subscribe () {
        const topic = this.newTopic
        if (!this.session) {
            return
        }

        const handler: SubscribeHandler = (args) => {
            this.topics[topic].messages.push(args[0])
            this.$forceUpdate()
        }

        const subscription = await this.$wamp.subscribe(topic, handler)

        // Registra el tema para ser mostrado en la pantalla
        this.topics[topic] = {
            name: topic,
            subscription,
            messages: [],
            currentMessage: '',
        }

        this.addRecentTopic(topic)

        this.subscribeDialog = false
    }

    /**
     * Envía un mensaje a uno de los temas observados por la aplicación
     */
    public async send () {
        this.$wamp.publish(this.currentTopic, [this.jsonEditor?.get()], {}, {
            exclude_me: false,
        })

        this.newMessageDialog = false
    }

    public async disconnect () {
        if (!this.session) {
            return
        }

        await this.$wamp.close()
        this.connected = false
        this.session = null
        this.topics = {}
    }

    public async unsubscribe (topic: Topic) {
        await this.wampSession?.unsubscribe(topic.subscription)
        this.$delete(this.topics, topic.name)
    }

    public addRecentTopic (topic: string) {
        this.recentTopics.push(topic)
        localStorage.setItem('wamp.recentTopics', JSON.stringify(this.recentTopics))
    }

    /**
     * Carga los temas recientes agregados
     */
    public loadRecentTopics () {
        let recent: string[] = JSON.parse(
            localStorage.getItem('wamp.recentTopics') || '[]',
        )

        if (!Array.isArray(recent)) {
            recent = []
        }

        this.recentTopics = recent
    }

    public created () {
       this.loadRecentTopics()
    }

    public async openMessageEditor () {
        this.newMessageDialog = true

        // El editor JSON ya se encuentra instanciado
        if (this.jsonEditor) {
            return
        }

        await this.$nextTick()

        const options: JSONEditorOptions = {
            language: 'es',
            languages: {
                es: {
                    'Select a node': 'Seleccionada un nodo...',
                },
            },
            mode: 'code',
            modes: ['code', 'form', 'text', 'tree', 'view', 'preview'],
            onError (err: any) {
                alert(err.toString())
            },
        }

        this.jsonEditor = new JSONEditor(this.editorContainer, options)
    }

}
